import { launchpadQueryClient } from '@/lib/launchpad/query-client';
import { Toaster, TooltipProvider } from '@mgrvtechgroup/admin-ds';
import { QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router';

/**
 * 런치패드 위저드 공통 레이아웃 라우트.
 *
 * MFMS에서 전역(main.tsx)에 있던 TooltipProvider + sonner Toaster를 런치패드
 * 라우트 서브트리로 한정해 재현하고, 전역 antd 에러 핸들러를 우회하기 위해
 * 런치패드 전용 QueryClient를 중첩 Provider로 덮어쓴다.
 */
export default function LaunchpadLayout() {
  return (
    <QueryClientProvider client={launchpadQueryClient}>
      <TooltipProvider>
        {/* launchpad-scope: 전역 base 헤딩 규칙을 preflight 상태로 되돌리는 스코프 (index.css) */}
        <div className="launchpad-scope">
          <Outlet />
        </div>
        <Toaster position="top-center" />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
